import { NgModule } from '@angular/core';

import { MwOverlayService } from './overlay.service';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  providers: [MwOverlayService],
})
export class MwOverlayModule {}
